import { UID } from '@common/interfaces/uid.interface';

export const generateId = (prefix: string): UID => {
    return (
        prefix +
        '_' +
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        })
    );
};
